export default __webpack_public_path__ + "static/media/bonfire-flipped.362fdc71.png";